import 'react-toastify/dist/ReactToastify.css'
import './globals.css'
import './i18n/config'

import App from 'App'
import { ThemeProvider } from 'contexts/theme-context'
import GlobalStyles from 'GlobalStyles'
import ClientErrorPage from 'pages/ClientErrorPage'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { ErrorBoundary } from 'react-error-boundary'
import { Provider } from 'react-redux'
import { store } from 'redux/store'
const container = document.getElementById('root') as HTMLElement

const root = ReactDOM.createRoot(container)

root.render(
  <React.StrictMode>
    <ThemeProvider initialTheme='dark'>
      <GlobalStyles />
      <Provider store={store}>
        <ErrorBoundary
          onReset={() => {
            console.log('Reset Error')
          }}
          FallbackComponent={ClientErrorPage}
        >
          <App />
        </ErrorBoundary>
      </Provider>
    </ThemeProvider>
  </React.StrictMode>
)
